(function() {
    'use strict';
    var app = angular.module('enervee');

    app.factory('GdprService', [
        '$q',
        'UtilService',
        'CmsContentService',
        function(
            $q,
            UtilService,
            CmsContentService
        ) {
            var _pub = {};
            var gdprEmails = UtilService.getSiteSetting('gdpr_emails', {});
            _pub.baseCmsKeys = {
                main: 'data_protection_disclaimer',
                cookie: 'data_protection_cookie_disclaimer',
            };
            _pub.cmsKeyParent = 'base:modals:';
            _pub.cmsKeys = {
                main: _pub.cmsKeyParent + _pub.baseCmsKeys.main,
                cookie: _pub.cmsKeyParent + _pub.baseCmsKeys.cookie,
            };
            _pub.cmsContext = {
                delete_mail_to_link: [
                    '<a href="mailto:' + gdprEmails.delete + '?subject={delete_subject}">{delete_text}</a>',
                    {
                        delete_subject: _pub.cmsKeyParent + 'gdpr_delete_email_subject',
                        delete_text: _pub.cmsKeyParent + 'gdpr_delete_email_link_text',
                    }
                ],
                access_mail_to_link: [
                    '<a href="mailto:' + gdprEmails.access + '?subject={access_subject}">{access_text}</a>',
                    {
                        access_subject: _pub.cmsKeyParent + 'gdpr_access_email_subject',
                        access_text: _pub.cmsKeyParent + 'gdpr_access_email_link_text',
                    }
                ]
            };


            _pub.getCmsText = function (prefix) {
                var gdprPromises = {
                    main: getGdprTextWithPrefix(_pub.baseCmsKeys.main, _pub.cmsContext, prefix),
                    cookie: getGdprTextWithPrefix(_pub.baseCmsKeys.cookie, _pub.cmsContext, prefix),
                };
                return $q.all(gdprPromises);
            };

            /**
             * Get the GDPR text, if any. If a prefix is passed but no text for it exists,
             * then the default text is retrieved using just the initial key.
             *
             * @param {String} key the initial CMS key, combined with the prefix, if passed
             * @param {String} [prefix] the prefix to the GDPR CMS key
             * @return {Promise} resolves to an object with CMS texts, or an empty object
             */
            function getGdprTextWithPrefix(key, context, prefix) {
                var deferred = $q.defer();
                var fullKey = (prefix || '') + key;
                CmsContentService.getMarketPlaceText(_pub.cmsKeyParent + fullKey, context).then(function(text) {
                    if (prefix && !text) {
                        // If there's a prefix, but we didn't get any text, try with just the key
                        CmsContentService.getMarketPlaceText(_pub.cmsKeyParent + key, context).then(function(text) {
                            deferred.resolve(text || '');
                        });
                    } else {
                        deferred.resolve(text || '');
                    }
                });
                return deferred.promise;
            }

            return _pub;
        }
    ]);
})();
